import { IntroSketch, StandardFrame, BreakdownSketch, SpeedComparison, SketchC } from "../../../../content/posts/stroboscope-timing/sketch.js";
import * as React from 'react';
export default {
  IntroSketch,
  StandardFrame,
  BreakdownSketch,
  SpeedComparison,
  SketchC,
  React
};